import type { ReactNode } from 'react';
import {
  useChatSidebarWorkBindings,
  type ChatSidebarWorkBindings,
} from './hooks/useChatSidebarWorkBindings';

/**
 * Resolves the Heidi Work half of the chat sidebar and hands it to whoever
 * renders the panel.
 *
 * `ChatSidebar` knows nothing about Work, Routines or the inbox — it takes
 * them as one `work` prop — and this is where the app shell supplies them, so
 * every surface that mounts the sidebar gets the same rows.
 *
 * It is a render prop rather than a wrapper around `ChatSidebar` for two
 * reasons: two of the bindings open a query and a mutation, so they must mount
 * exactly where the sidebar does and not one component higher; and a wrapper
 * would put a fresh shell-to-Chat import in a set that only shrinks.
 */
export function ChatSidebarWork({
  children,
}: {
  children: (work: ChatSidebarWorkBindings) => ReactNode;
}): JSX.Element {
  return <>{children(useChatSidebarWorkBindings())}</>;
}
